import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";

import { screen, spacing } from "../../../styles/mixins";
import { useGetResizer } from "../../../contexts/Resizer";
import { motion, useTransform, useViewportScroll } from "framer-motion";
import { path as pathHelper } from "d3-path";
import personFallingImage from "../../../images/falling-woman.png";
import fallingMaskOutro from "../../../images/falling-mask-outro.svg";
// import { Link } from "gatsby";
import {
	pSmall,
	fontSurt,
	outroTitle,
	h3,
	h5,
} from "../../../styles/typography";
import { easing } from "../../../util/math";
// import { useInView } from "react-intersection-observer";
import Button from "../../UI/Button";

const Visualisation = styled.div`
	${spacing("marginTop", "xxl")};
	background-color: black;
	position: relative;
	//overflow: hidden;
	height: 300vh;
`;

const StickyContainer = styled.div`
	height: 100vh;
	position: sticky;
	top: 0;
`;
// const Mask = styled.div`
// 	position: absolute;
// 	top: 0;
// 	left: 0;
// 	height: ${({ menuHeight }) => menuHeight}px;
// 	background-color: black;
// 	width: 100%;
// 	z-index: 3;
// `;
const Inner = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	overflow: hidden;
	/* padding-top: ${({ menuHeight }) => menuHeight}px; */
`;
const SvgWrapper = styled(motion.div)`
	min-width: 100%;
	width: auto;
	height: auto;
	min-height: 100%;
	position: absolute;
	top: 0;
	left: 50%;
`;

const Svg = styled.svg`
	min-width: 100%;
	min-height: 100%;
`;

const FallingManWrapper = styled.div`
	width: 140px;
	height: 2000px;
	position: absolute;
	top: 0;
	left: calc(50% - 70px);
	mask-image: url(${fallingMaskOutro});
	mask-position: top;
	mask-repeat: no-repeat;
`;

const FallingMan = styled(motion.img)`
	width: 100%;
	will-change: transform, opacity;
`;

const NextContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 0;
	width: 100%;
	text-align: center;
`;
const NextTitle = styled(motion.h2)`
	${h3};
	${spacing("marginBottom", "l")};
	will-change: opacity;

	@media ${screen("md")} {
		${outroTitle};
	}

	span {
		${fontSurt};
	}
`;
const NextSubtitle = styled(motion.div)`
	${pSmall};
	${spacing("marginBottom", "l")};
	will-change: opacity;
	font-weight: bold;
`;

const ComingSoon = styled.div`
	color: white;
	${h5};
	${fontSurt};
`;

export default function Outro({ title, subtitle, link, linkText }) {
	const area = useGetResizer();
	const svgRef = useRef();
	const [showTitle, setShowTitle] = useState(false);
	const [svgOffset, setSvgOffset] = useState(-950);
	const [winHeight, setWinHeight] = useState(1440);
	const containerRef = useRef();
	const [containerBounds, setContainerBounds] = useState({
		top: 0,
		bottom: 100,
	});
	const viewportScroll = useViewportScroll();
	useEffect(() => {
		let element = containerRef.current;
		let scrollY = window.scrollY;
		let rect = element.getBoundingClientRect();
		setContainerBounds({
			top: rect.top + scrollY,
			bottom: rect.bottom + scrollY - window.innerHeight,
		});
	}, [area]);

	useEffect(() => {
		let rect = svgRef.current.getBoundingClientRect();
		let heightDiff = rect.height - window.innerHeight;
		setSvgOffset(heightDiff > 0 ? -heightDiff : 0);
		setWinHeight(window.innerHeight);
	}, [area]);
	const progress = useTransform(
		viewportScroll.scrollY,
		[containerBounds.top, containerBounds.bottom],
		[0, 1],
		{
			clamp: false,
		}
	);

	let rayOfLight = pathHelper();
	rayOfLight.moveTo(578, 40);
	rayOfLight.lineTo(874, 40);
	rayOfLight.lineTo(1480, 1289);
	rayOfLight.lineTo(-30, 1289);
	rayOfLight.lineTo(578, 40);
	rayOfLight.closePath();

	let y = useTransform(progress, [-0.2, 1.5], [-100, winHeight / 2], {
		ease: easing.outQuad,
	});
	let rotate = useTransform(progress, [-0.2, 1.5], [10, -30], {
		ease: easing.outQuad,
	});
	let opacity = useTransform(progress, [0.35, 0.8], [1, 0.3], { clamp: true });

	let svgY = useTransform(progress, [0, 1], [0, svgOffset], {
		ease: easing.outQuad,
	});

	useEffect(() =>
		progress.onChange((val) => {
			if (val > 0.4) {
				setShowTitle(true);
			} else {
				setShowTitle(false);
			}
		})
	);

	// useEffect(() => {
	// 	return progress.onChange((val) => console.log(val));
	// });
	return (
		<Visualisation ref={containerRef}>
			<StickyContainer>
				<Inner>
					<SvgWrapper ref={svgRef} style={{ y: svgY, x: "-50%" }}>
						<Svg
							width="1440"
							height="1289"
							viewBox="0 0 1440 1289"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							{/* <mask
								id="mask0"
								mask-type="alpha"
								maskUnits="userSpaceOnUse"
								x="596"
								y="0"
								width="262"
								height="70">
								<path
									d="M687.507 0C674.985 0.963235 649.363 2.88971 647.051 2.88971L610.449 16.375L596 28.8971L604.669 46.2353L628.75 56.8309C649.299 61.0049 691.168 69.3529 694.25 69.3529H751.081C776.446 65.8211 828.14 58.3721 831.993 56.8309C835.846 55.2897 848.368 47.1985 854.147 43.3456L858 31.7868L854.147 23.1176L831.993 8.66912L771.309 0H736.632H687.507Z"
									fill="#5B5B5A"
								/>
							</mask>
							<g mask="url(#mask0)">
								<path
									d="M687.507 0C674.985 0.963235 649.363 2.88971 647.051 2.88971L610.449 16.375L596 28.8971L604.669 46.2353L628.75 56.8309C649.299 61.0049 691.168 69.3529 694.25 69.3529H751.081C776.446 65.8211 828.14 58.3721 831.993 56.8309C835.846 55.2897 848.368 47.1985 854.147 43.3456L858 31.7868L854.147 23.1176L831.993 8.66912L771.309 0H736.632H687.507Z"
									fill="#5B5B5A"
								/>
								<path
									d="M645.125 53.942 L612.375 44.3096 L604.187 37.567 L596 30.8243 L565.176 -16.3742 L848.368 -24.0801 L856.074 27.9346 L853.184 37.567 L842.588 44.3096 L792.5 53.942 L709.662 57.7949 L645.125 53.942Z"
									fill="white"
								/>
							</g> */}

							<path
								opacity={"0.9"}
								d={rayOfLight.toString()}
								fill="url(#paint0_radial)"
							/>

							<g transform="translate(576 0)">
								<g>
									<ellipse
										rx="150.229"
										ry="44"
										transform="matrix(1 0 0 -1 150.229 44)"
										fill="white"
									/>
								</g>
							</g>

							<g opacity="0.6" transform="translate(576 0)">
								<mask
									id="mask1"
									mask-type="alpha"
									maskUnits="userSpaceOnUse"
									x="0"
									y="0"
									width="301"
									height="88">
									<ellipse
										rx="150.229"
										ry="44"
										transform="matrix(1 0 0 -1 150.229 44)"
										fill="black"
									/>
								</mask>
								<g mask="url(#mask1)">
									<ellipse
										rx="150.229"
										ry="44"
										transform="matrix(1 0 0 -1 150.229 44)"
										fill="url(#paint0_linear)"
									/>
									<path
										d="M300.729 -4C300.729 -28.3005 233.347 -48 150.229 -48C67.1097 -48 -0.271484 -28.3005 -0.271484 -4C-0.271484 20.3005 67.1097 40 150.229 40C233.347 40 300.729 20.3005 300.729 -4Z"
										fill="black"
									/>
								</g>
							</g>

							<defs>
								<radialGradient
									id="paint0_radial"
									cx="0"
									cy="0"
									r="1"
									gradientUnits="userSpaceOnUse"
									gradientTransform="translate(720 -30.0001) rotate(90) scale(1258.18 1500.21)">
									<stop stopColor="white" />
									<stop
										offset="0.476881"
										stopColor="white"
										stopOpacity="0.82"
									/>
									<stop offset="1" stopColor="white" stopOpacity="0" />
								</radialGradient>

								<linearGradient
									id="paint0_linear"
									x1="295.229"
									y1="49.5"
									x2="27.7285"
									y2="43.9999"
									gradientUnits="userSpaceOnUse">
									<stop stopColor="#222222" />
									<stop offset="0.0877749" stopColor="#3D3D3D" />
									<stop offset="0.84375" stopColor="#252525" />
									<stop offset="1" stopColor="#141414" />
								</linearGradient>
							</defs>
						</Svg>
					</SvgWrapper>
					<FallingManWrapper>
						<FallingMan
							src={personFallingImage}
							style={{ y: y, rotate, opacity }}
						/>
					</FallingManWrapper>
					<NextContainer>
						<NextSubtitle
							initial={{ opacity: 0 }}
							animate={{ opacity: showTitle ? 1 : 0 }}>
							{subtitle}
						</NextSubtitle>
						<NextTitle
							initial={{ opacity: 0 }}
							animate={{ opacity: showTitle ? 1 : 0 }}
							transition={{ delay: 0.2 }}
							dangerouslySetInnerHTML={{ __html: title }}
						/>
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: showTitle ? 1 : 0 }}
							transition={{ delay: 0.4 }}>
							{link ? (
								<Button theme={"dark"} to={link}>
									{linkText}
								</Button>
							) : (
								<ComingSoon>{linkText}</ComingSoon>
							)}
						</motion.div>
					</NextContainer>
				</Inner>
			</StickyContainer>
		</Visualisation>
	);
}
